module.exports = __webpack_public_path__ + "static/minotaur-boros-c7ece26d8bc074ec79a379dedfd9d8ea.png";